import ClientConfig from "../configuration/client_config.json";

class AmbassadorHelper{
    getDisplayName(ambassador){
        const storefront_details = this.getStoreFrontDetails(ambassador);
        const displayName = (storefront_details && storefront_details.display_name)
            ? storefront_details.display_name : ambassador.profileTitle;
        return displayName;
    }
    getDisplayNameFromApi(ambassador){
        if(!ambassador) return "";
        const storefront_details = ambassador.storefront_details || {};
        const displayName = (storefront_details && storefront_details.display_name)
            ? storefront_details.display_name : `${ambassador.first_name} ${ambassador.last_name}`;
        return displayName;
    }
    getStoreFrontDetails(ambassador) {
        if (ambassador && ambassador.data && ambassador.data.storefront_details)
            return ambassador.data.storefront_details
        else return {}
    }
    getImages = (ambassador) => {
        if (ambassador && ambassador.data && ambassador.data.images)
            return ambassador.data.images;
        else return false;
    }
    getAmbassadorCover = (ambassador) => {
        const images = this.getImages(ambassador);
        if (images && images.cover) {
            const values = Object.values(images.cover);
            return values[values.length - 1]
        } else {
            return this.clientConfigAmbassador().default_profile_cover_url;
        }
    }
    clientConfigAmbassador(){
        if(ClientConfig && ClientConfig.client_config.client && ClientConfig.client_config.client.ambassador){
            return ClientConfig.client_config.client.ambassador;
        }
        else
            return {}
    }
    getAmbassadorPhoto = (ambassador) => {
        const images = this.getImages(ambassador);
        if (images && images.photo) {
            const values = Object.values(images.photo);
            return values[values.length - 1]
        } else if (ambassador && ambassador.data && ambassador.data.profilePhoto) {
            return this.validateProfileUrl(ambassador.data.profilePhoto);
        } else {
            return this.clientConfigAmbassador().default_profile_photo_url;
        }
    }
    getCreatorPhoto = (creator) => {
        if (creator?.thumbnail) {
            return creator.thumbnail;
        } else {
            return this.clientConfigAmbassador().default_profile_photo_url;
        }
    }
    getAmbassadorPhotoFromApi = (ambassador) => {
        const images = ambassador.images || false;
        if (images && images.photo) {
            const values = Object.values(images.photo);
            return values[values.length - 1]
        } else if (ambassador && ambassador.profile_picture) {
            return this.validateProfileUrl(ambassador.profile_picture);
        } else {
            return this.clientConfigAmbassador().default_profile_photo_url;
        }
    }
    validateProfileUrl(profilePhoto){
        if (profilePhoto && profilePhoto.indexOf("http") === -1)
            return `https://api.tvpage.com${profilePhoto}`;
        else if(profilePhoto){
            return profilePhoto;
        }
    }
    getCreatorBio = (storefront_details) => {
        if(storefront_details && storefront_details.creator_bio){
            return storefront_details.creator_bio
        }else{
            return this.clientSection().ambassador_program_default_bio;
        }
    }
    clientConfigAmbassador(){
        if(ClientConfig && ClientConfig.client_config.client && ClientConfig.client_config.client.ambassador){
            return ClientConfig.client_config.client.ambassador;
        }
        else
            return {}
    }
    clientSection(){
        if(ClientConfig && ClientConfig.client_config.client){
            return ClientConfig.client_config.client;
        }
        else
            return {}
    }
}

export default new AmbassadorHelper;